// NAS Archive — tab constants (internal ?tab= state, independent of ?view=).
export const NAS_TABS = [
  { key: 'browse', label: 'フォルダー', testid: 'nas-tab-browse', flag: 'nas_archive_browse' },
  { key: 'search', label: '検索', testid: 'nas-tab-search', flag: 'nas_archive_search' },
  { key: 'changes', label: '最近の変更', testid: 'nas-tab-changes', flag: 'nas_archive_changes' },
  { key: 'status', label: '状態', testid: 'nas-tab-status', flag: 'nas_archive_status' },
];

export const DEFAULT_TAB = 'browse';
